export default "__VITE_ASSET__CtUrxWMp__"